import React from 'react';

import { Box, Flex, FlexProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export interface Filter<T> {
  label: string;
  value: T | undefined;
}

interface ChipFiltersProps<T> extends FlexProps {
  filters: Filter<T>[];
  selectedFilter?: Filter<T>;
  setSelectedFilter: (filter: Filter<T> | undefined) => void;
}

export function ChipFilters<T>({ filters, selectedFilter, setSelectedFilter, ...flexProps }: ChipFiltersProps<T>) {
  const { t } = useTranslation();

  const all = {
    label: t('APP.ACTIONS.ALL'),
    value: undefined
  };

  return (
    <Flex direction="row" align="center" wrap="wrap" w="100%" {...flexProps}>
      {[all, ...filters].map((filter, index) => (
        <Box
          p="6px 12px"
          sx={(theme) => ({
            cursor: 'pointer',
            backgroundColor: selectedFilter?.value === filter.value ? theme.other.gray.bg : 'transparent',
            borderRadius: '50px',
            fontSize: '0.9rem',
            color: selectedFilter?.value === filter.value ? theme.other.text.default : theme.other.text.dimmed
          })}
          key={index}
          onClick={() => setSelectedFilter(filter.value ? filter : undefined)}>
          {filter.label}
        </Box>
      ))}
    </Flex>
  );
}
